<div class="attachments-container">
  <div class="attachments-header">
    <div class="attachments-title">
      Attachments ({{ attachments.length }})
      @if (isEdit) {
        <button rktButton btnType="link" class="attachments-btn" (click)="onAddAttachment()">
          <rkt-icon name="plus"></rkt-icon>
          Add
        </button>
      }
    </div>
    <div class="attachment-toggle-buttons">
      <button
        rktButton
        btnType="link"
        class="attachment-toggle-btn"
        [class.active]="attachmentsView === 'tiles'"
        (click)="onToggleAttachmentsView('tiles')"
      >
        <rkt-icon name="tiles"></rkt-icon>
      </button>
      <button
        rktButton
        btnType="link"
        class="attachment-toggle-btn"
        [class.active]="attachmentsView === 'list'"
        (click)="onToggleAttachmentsView('list')"
      >
        <rkt-icon name="list"></rkt-icon>
      </button>
    </div>
  </div>

  @if (!loading && attachments.length) {
    @if (attachmentsView === 'tiles') {
      <rkt-carousel [items]="attachments" [itemsVisible]="2" [itemsScroll]="2">
        <ng-template let-item rktCarouselItem="item">
          <div class="file-item" (click)="onViewAttachmentCLick(item)">
            <div class="file-name">
              <rkt-icon [name]="'attachment'"></rkt-icon>
              <span class="file-name-text">{{ item.name }}</span>
            </div>
            <div class="file-image">
              @if (item.thumbnailUrl?.value) {
                <img [src]="$safeNavigationMigration(item.thumbnailUrl?.value)" [alt]="item.name" />
              }
              <div class="banner-text">{{ getAttachmentScanLabel(item) }}</div>
              @if (isEdit) {
                <div class="action-buttons">
                  <rkt-icon class="trash-button" [name]="'trash'" (click)="onActionButtonClick('DELETE', item.id, $event)"></rkt-icon>
                  <rkt-icon class="edit-button" [name]="'edit'" (click)="onActionButtonClick('EDIT', item.id, $event)"></rkt-icon>
                  <rkt-icon
                    class="download-button"
                    [name]="'download'"
                    (click)="onActionButtonClick('DOWNLOAD', item.id, $event)"
                  ></rkt-icon>
                </div>
              }
            </div>
          </div>
        </ng-template>
      </rkt-carousel>
    } @else {
      <div class="attachment-upload-selected-container">
        @for (attachment of attachments; track attachment) {
          <div class="uploaded-attachment-item" (click)="onViewAttachmentCLick(attachment)">
            <rkt-icon class="attachment-status" name="check"></rkt-icon>
            <div class="name">{{ attachment.name }}</div>
            @if (isEdit) {
              <button
                (click)="onActionButtonClick('EDIT', attachment.id, $event)"
                class="attachment-action-button attachment-action-button-edit"
              >
                <rkt-icon name="edit"></rkt-icon>
              </button>
            }
            @if (isEdit) {
              <button
                (click)="onActionButtonClick('DELETE', attachment.id, $event)"
                class="attachment-action-button attachment-action-button-delete"
              >
                <rkt-icon name="trash"></rkt-icon>
              </button>
            }
          </div>
        }
      </div>
    }
  }
</div>
